import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../../pages-styles/project-consultancy.css';
import { usePageMeta } from '../../hooks/usePageMeta';

export default function Planning() {
  usePageMeta(
    'Project Planning & Development Support - Magbity Agency Ltd',
    'Professional project planning, roadmap development, resource management, and implementation support.'
  );

  useEffect(() => {
    const el = document.querySelector('.planning-3d-card');
    if (el) el.classList.add('enter');
  }, []);

  return (
    <div className="project-consultancy">
      <section className="consultancy-hero-banner planning-hero">
        <div className="consultancy-hero-overlay"></div>
        <div className="consultancy-hero-content">
          <div className="consultancy-hero-text">
            <h1>Project Planning & Development Support</h1>
            <p>
              Strategic planning from vision to execution. We develop detailed project roadmaps, resource allocation plans, 
              risk mitigation strategies, and implementation frameworks to ensure your project achieves objectives on time 
              and within budget.
            </p>
          </div>

          <div className="planning-illustration">
            <div className="planning-3d-scene">
              <div className="planning-3d-card">
                <div className="face front">
                  <svg width="220" height="220" viewBox="0 0 220 220" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                      <linearGradient id="planningGrad" x1="0" x2="1">
                        <stop offset="0%" stopColor="#16c784" />
                        <stop offset="100%" stopColor="#00d4ff" />
                      </linearGradient>
                    </defs>
                    <rect x="10" y="10" width="200" height="200" rx="16" fill="url(#planningGrad)" opacity="0.12" />
                    <g transform="translate(35,35) scale(0.9)">
                      <rect x="10" y="15" width="75" height="8" rx="3" fill="#fff" opacity="0.14" />
                      <rect x="10" y="35" width="55" height="6" rx="2" fill="#fff" opacity="0.12" />
                      <rect x="10" y="50" width="75" height="8" rx="3" fill="#fff" opacity="0.14" />
                      <rect x="10" y="70" width="55" height="6" rx="2" fill="#fff" opacity="0.12" />
                      <rect x="10" y="85" width="75" height="8" rx="3" fill="#fff" opacity="0.14" />
                    </g>
                  </svg>
                  <div className="card-label">Project Timeline</div>
                </div>
                <div className="face back">
                  <h4>Planning Outcomes</h4>
                  <p>Detailed roadmaps, resource plans, risk registers and implementation timelines.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="consultancy-services planning-details">
        <h2>Planning & Development Services</h2>
        <div className="services-list">
          <div className="service-item left">
            <div className="service-content">
              <h3>Project Roadmap & Milestone Development</h3>
              <p>
                Create realistic, phased project roadmaps with clear milestones, deliverables, and timelines. 
                We break complex projects into manageable phases with defined success criteria.
              </p>
            </div>
            <div className="service-icon-wrapper">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="#16c784" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 10h10v2H7zm0 4h10v2H7z" opacity=".2"/>
                <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 10h10v2H7zm0 4h10v2H7z"/>
              </svg>
            </div>
          </div>

          <div className="service-item right">
            <div className="service-icon-wrapper">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="#16c784" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" opacity=".2"/>
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
              </svg>
            </div>
            <div className="service-content">
              <h3>Resource Planning & Budget Allocation</h3>
              <p>
                Develop comprehensive resource allocation plans including budget forecasting, staffing requirements, 
                procurement planning, and cost control mechanisms.
              </p>
            </div>
          </div>

          <div className="service-item left">
            <div className="service-content">
              <h3>Risk Management & Contingency Planning</h3>
              <p>
                Identify potential risks, assess their impact, and develop mitigation strategies and contingency plans 
                to protect project success and stakeholder interests.
              </p>
            </div>
            <div className="service-icon-wrapper">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="#16c784" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.72-7 8.77V12H5V6.3l7-3.11v8.8z" opacity=".2"/>
                <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.72-7 8.77V12H5V6.3l7-3.11v8.8z"/>
              </svg>
            </div>
          </div>

          <div className="service-item right">
            <div className="service-icon-wrapper">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="#16c784" xmlns="http://www.w3.org/2000/svg">
                <path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z" opacity=".2"/>
                <path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"/>
              </svg>
            </div>
            <div className="service-content">
              <h3>Stakeholder Communication & Engagement</h3>
              <p>
                Design stakeholder engagement strategies, communication plans, and feedback mechanisms to ensure 
                alignment and buy-in throughout the project lifecycle.
              </p>
            </div>
          </div>

          <div className="service-item left">
            <div className="service-content">
              <h3>Monitoring, Evaluation & Control Framework</h3>
              <p>
                Establish KPIs, create monitoring dashboards, and define control mechanisms to track progress, 
                identify issues early, and maintain project momentum.
              </p>
            </div>
            <div className="service-icon-wrapper">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="#16c784" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 13h2v8H3zm4-8h2v16H7zM21 4h-7V3h-2v18h9V4h-2V3zm-4 2v12h-3V6h3z" opacity=".2"/>
                <path d="M3 13h2v8H3zm4-8h2v16H7zM21 4h-7V3h-2v18h9V4h-2V3zm-4 2v12h-3V6h3z"/>
              </svg>
            </div>
          </div>

          <div className="service-item right">
            <div className="service-icon-wrapper">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="#16c784" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 9.2h3V19H5zM10.6 5h2.8v14h-2.8zm5.6 8H19v6h-2.8z" opacity=".2"/>
                <path d="M5 9.2h3V19H5zM10.6 5h2.8v14h-2.8zm5.6 8H19v6h-2.8z"/>
              </svg>
            </div>
            <div className="service-content">
              <h3>Implementation Support & Project Handover</h3>
              <p>
                Provide on-site or remote implementation support, change management guidance, and structured handover 
                processes to ensure smooth project transition and adoption.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="planning-phases">
        <h2>Planning Lifecycle</h2>
        <div className="process-steps">
          <div className="step">
            <div className="step-number">1</div>
            <h4>Initiation</h4>
            <p>Define project objectives, scope, and stakeholders</p>
          </div>
          <div className="step">
            <div className="step-number">2</div>
            <h4>Planning</h4>
            <p>Develop comprehensive plans for all aspects</p>
          </div>
          <div className="step">
            <div className="step-number">3</div>
            <h4>Resource Allocation</h4>
            <p>Assign teams, budget, and equipment</p>
          </div>
          <div className="step">
            <div className="step-number">4</div>
            <h4>Execution</h4>
            <p>Implement planned activities and deliverables</p>
          </div>
          <div className="step">
            <div className="step-number">5</div>
            <h4>Monitoring</h4>
            <p>Track progress and manage scope changes</p>
          </div>
          <div className="step">
            <div className="step-number">6</div>
            <h4>Closure</h4>
            <p>Complete deliverables and transition to operations</p>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <h2>Ready to Plan Your Project Successfully?</h2>
        <p>Let's develop a comprehensive plan that keeps your project on track and on budget.</p>
        <Link to="/contact" className="cta-button">Request Planning Support</Link>
      </section>
    </div>
  );
}
